const projectContext = require.context('./', false, /\.mdx$/);
export const projectPages = projectContext.keys().map((filePath) => {
  const module = projectContext(filePath);
  return { ...module.metadata, Component: module.default };
});
export const projectBySlug = Object.fromEntries(projectPages.map((project) => [String(project.slug), project]));
